import { LineItem } from "@/models/campaign";

const LineItemsHelper = {
  filterLineItemsByDefinition(
    definition: string | string[],
    lineItems: LineItem[]
  ): LineItem[] {
    const d = Array.isArray(definition) ? definition : [definition];
    const items = lineItems.filter((l) => {
      return l.definitionValueIds.some((e) => d.includes(e));
    });

    return items;
  },
};

export default LineItemsHelper;
